// extracted by mini-css-extract-plugin
export default {"card":"account-section_card__0k-mv","title":"account-section_title__ZUvZN","description":"account-section_description__YkjIE"};